var map = {
	"./en-RU.json": [
		1474,
		21
	],
	"./en-RU/blog.json": [
		1452,
		8
	],
	"./en-RU/calculator.json": [
		1453,
		9
	],
	"./en-RU/cases.json": [
		1454,
		10
	],
	"./en-RU/common.json": [
		1455,
		11
	],
	"./en-RU/community.json": [
		1456,
		12
	],
	"./en-RU/constructor.json": [
		1457,
		13
	],
	"./en-RU/docs.json": [
		1458,
		14
	],
	"./en-RU/error.json": [
		1459,
		15
	],
	"./en-RU/events.json": [
		1460,
		16
	],
	"./en-RU/footer.json": [
		1461,
		17
	],
	"./en-RU/forms.json": [
		1462,
		18
	],
	"./en-RU/header.json": [
		1463,
		19
	],
	"./en-RU/interconnect.json": [
		1464,
		20
	],
	"./en-RU/marketplace.json": [
		1465,
		22
	],
	"./en-RU/navigation.json": [
		1466,
		23
	],
	"./en-RU/partners.json": [
		1467,
		24
	],
	"./en-RU/region-tooltip.json": [
		1468,
		25
	],
	"./en-RU/search.json": [
		1469,
		26
	],
	"./en-RU/services.json": [
		1470,
		27
	],
	"./en-RU/solutions.json": [
		1471,
		28
	],
	"./en-RU/speechkit-demo.json": [
		1472,
		29
	],
	"./en-RU/translate-demo.json": [
		1473,
		30
	],
	"./en.json": [
		1475,
		44
	],
	"./en/blog.json": [
		1430,
		31
	],
	"./en/calculator.json": [
		1431,
		32
	],
	"./en/cases.json": [
		1432,
		33
	],
	"./en/common.json": [
		1433,
		34
	],
	"./en/community.json": [
		1434,
		35
	],
	"./en/constructor.json": [
		1435,
		36
	],
	"./en/docs.json": [
		1436,
		37
	],
	"./en/error.json": [
		1437,
		38
	],
	"./en/events.json": [
		1438,
		39
	],
	"./en/footer.json": [
		1439,
		40
	],
	"./en/forms.json": [
		1440,
		41
	],
	"./en/header.json": [
		1441,
		42
	],
	"./en/interconnect.json": [
		1442,
		43
	],
	"./en/marketplace.json": [
		1443,
		45
	],
	"./en/navigation.json": [
		1444,
		46
	],
	"./en/partners.json": [
		1445,
		47
	],
	"./en/region-tooltip.json": [
		1446,
		48
	],
	"./en/search.json": [
		1447,
		49
	],
	"./en/services.json": [
		1448,
		50
	],
	"./en/solutions.json": [
		1449,
		51
	],
	"./en/speechkit-demo.json": [
		1450,
		52
	],
	"./en/translate-demo.json": [
		1451,
		53
	],
	"./ru-KZ.json": [
		1499,
		68
	],
	"./ru-KZ/blog.json": [
		1476,
		54
	],
	"./ru-KZ/calculator.json": [
		1477,
		55
	],
	"./ru-KZ/cases.json": [
		1478,
		56
	],
	"./ru-KZ/common.json": [
		1479,
		57
	],
	"./ru-KZ/community.json": [
		1480,
		58
	],
	"./ru-KZ/constructor.json": [
		1481,
		59
	],
	"./ru-KZ/docs.json": [
		1482,
		60
	],
	"./ru-KZ/error.json": [
		1483,
		61
	],
	"./ru-KZ/events.json": [
		1484,
		62
	],
	"./ru-KZ/features.json": [
		1485,
		63
	],
	"./ru-KZ/footer.json": [
		1486,
		64
	],
	"./ru-KZ/forms.json": [
		1487,
		65
	],
	"./ru-KZ/header.json": [
		1488,
		66
	],
	"./ru-KZ/interconnect.json": [
		1489,
		67
	],
	"./ru-KZ/marketplace.json": [
		1490,
		69
	],
	"./ru-KZ/navigation.json": [
		1491,
		70
	],
	"./ru-KZ/partners.json": [
		1492,
		71
	],
	"./ru-KZ/region-tooltip.json": [
		1493,
		72
	],
	"./ru-KZ/search.json": [
		1494,
		73
	],
	"./ru-KZ/services.json": [
		1495,
		74
	],
	"./ru-KZ/solutions.json": [
		1496,
		75
	],
	"./ru-KZ/speechkit-demo.json": [
		1497,
		76
	],
	"./ru-KZ/translate-demo.json": [
		1498,
		77
	],
	"./ru-RU.json": [
		1523,
		92
	],
	"./ru-RU/blog.json": [
		1500,
		78
	],
	"./ru-RU/calculator.json": [
		1501,
		79
	],
	"./ru-RU/cases.json": [
		1502,
		80
	],
	"./ru-RU/common.json": [
		1503,
		81
	],
	"./ru-RU/community.json": [
		1504,
		82
	],
	"./ru-RU/constructor.json": [
		1505,
		83
	],
	"./ru-RU/docs.json": [
		1506,
		84
	],
	"./ru-RU/error.json": [
		1507,
		85
	],
	"./ru-RU/events.json": [
		1508,
		86
	],
	"./ru-RU/features.json": [
		1509,
		87
	],
	"./ru-RU/footer.json": [
		1510,
		88
	],
	"./ru-RU/forms.json": [
		1511,
		89
	],
	"./ru-RU/header.json": [
		1512,
		90
	],
	"./ru-RU/interconnect.json": [
		1513,
		91
	],
	"./ru-RU/marketplace.json": [
		1514,
		93
	],
	"./ru-RU/navigation.json": [
		1515,
		94
	],
	"./ru-RU/partners.json": [
		1516,
		95
	],
	"./ru-RU/region-tooltip.json": [
		1517,
		96
	],
	"./ru-RU/search.json": [
		1518,
		97
	],
	"./ru-RU/services.json": [
		1519,
		98
	],
	"./ru-RU/solutions.json": [
		1520,
		99
	],
	"./ru-RU/speechkit-demo.json": [
		1521,
		100
	],
	"./ru-RU/translate-demo.json": [
		1522,
		101
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 631;
module.exports = webpackAsyncContext;